export const BrandsData = [
    {
        category: ["spirits"],
        img: "abasolo.svg",
    },
    {
        category: ["w&j"],
        img: "AcquaPanna.svg",
    },
    {
        category: ["spirits"],
        img: "anchoreyes.svg",
    },
    {
        category: ["spirits"],
        img: "amaroangostura.svg",
    },
    {
        category: ["wines"],
        img: "aromo.svg",
    },
    {
        category: ["beers"],
        img: "Asahi.svg",
    },
    {
        category: ["wines"],
        img: "avgvstvs.svg",
    },
    {
        category: ["wines"],
        img: "Belaire.svg",
    },
    {
        category: ["spirits"],
        img: "Bols.svg",
    },
    {
        category: ["spirits"],
        img: "Bulldog.svg",
    },
    {
        category: ["wines"],
        img: "caleuche.svg",
    },
    {
        category: ["beers"],
        img: "cerveceria14.svg",
    },
    {
        category: ["wines"],
        img: "chateaularteau.svg",
    },
    {
        category: ["wines"],
        img: "chateausenilhac.svg",
    },
    {
        category: ["spirits"],
        img: "chinola.svg",
    },
    {
        category: ["spirits"],
        img: "cihuatan.svg",
    },
    {
        category: ["wines"],
        img: "cruzalba.svg",
    },
    {
        category: ["spirits"],
        img: "cuttysark.svg",
    },
    {
        category: ["beers"],
        img: "Delirium.svg",
    },
    {
        category: ["wines"],
        img: "dogma.svg",
    },
    {
        category: ["spirits"],
        img: "domainecanton.svg",
    },
    {
        category: ["spirits"],
        img: "drambuie-seeklogo-3.svg",
    },
    {
        category: ["spirits"],
        img: "Elrecuerdo.svg",
    },
    {
        category: ["spirits"],
        img: "Espolon.svg",
    },
    {
        category: ["spirits"],
        img: "evanwilliams.svg",
    },
    {
        category: ["spirits"],
        img: "Glenfiddich.svg",
    },
    {
        category: ["spirits"],
        img: "GrandMarnier.svg",
    },
    {
        category: ["spirits"],
        img: "granmalo.svg",
    },
    {
        category: ["spirits"],
        img: "grants.svg",
    },
    {
        category: ["beers"],
        img: "Grolsch.svg",
    },
    {
        category: ["spirits"],
        img: "hpnotiq.svg",
    },
    {
        category: ["spirits"],
        img: "Jagermeister.svg",
    },
    {
        category: ["spirits"],
        img: "Licor43.svg",
    },
    {
        category: ["spirits"],
        img: "lolea.svg",
    },
    {
        category: ["spirits"],
        img: "luxardo.svg",
    },
    {
        category: ["beers"],
        img: "mahou.svg",
    },
    {
        category: ["wines"],
        img: "marfrades.svg",
    },
    {
        category: ["spirits"],
        img: "martinmillers.svg",
    },
    {
        category: ["wines"],
        img: "minuty.svg",
    },
    {
        category: ["spirits"],
        img: "Monkeyshoulder.svg",
    },
    {
        category: ["spirits"],
        img: "nixta.svg",
    },
    {
        category: ["spirits"],
        img: "nuvo.svg",
    },
    {
        category: ["w&j", "groceries"],
        img: "Ocean.svg",
    },
    {
        category: ["spirits"],
        img: "ojotigre.svg",
    },
    {
        category: ["spirits"],
        img: "pama.svg",
    },
    {
        category: ["beers"],
        img: "Peroni.svg",
    },
    {
        category: ["w&j"],
        img: "Perrier.svg",
    },
    {
        category: ["spirits"],
        img: "PuertodeIndias.svg",
    },
    {
        category: ["wines"],
        img: "ramonbilbao.svg",
    },
    {
        category: ["waters"],
        img: "SPellegrino.svg",
    },
    {
        category: ["wines"],
        img: "santamargherita.svg",
    },
    {
        category: ["wines"],
        img: "stambecco.svg",
    },
    {
        category: ["spirits"],
        img: "suze.svg",
    },
    {
        category: ["spirits"],
        img: "tequilaocho.svg",
    },
    {
        category: ["wines"],
        img: "terreliade.svg",
    },
    {
        category: ["spirits"],
        img: "theglenrothes.svg",
    },
    {
        category: ["spirits"],
        img: "Titos.svg",
    },
    {
        category: ["wines"],
        img: "Torresella.svg",
    },
    // {
    //     category: ["spirits"],
    //     img: "TullamoreDew.svg",
    // },
    // {
    //     category: ["groceries"],
    //     img: "Yucateco.svg",
    // },
];
